// controllers/map_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["container", "prevButton", "nextButton"];
  connect() {
    // Prüfen, ob Touchscreen vorhanden ist
    this.isTouchDevice = matchMedia("(pointer: coarse)").matches;

    // Buttons nur anzeigen/initialisieren, wenn kein Touchgerät
    if (!this.isTouchDevice) {
      this.onScrollOrResize = this.updateButtons.bind(this);
      this.resizeObserver = new ResizeObserver(this.onScrollOrResize);
      this.resizeObserver.observe(this.containerTarget);
      this.containerTarget.addEventListener("scroll", this.onScrollOrResize);

      this.updateButtons();
    } else {
      // Auf Touchgeräten Buttons ausblenden
      this.prevButtonTarget.style.display = "none";
      this.nextButtonTarget.style.display = "none";
    }
  }

  disconnect() {
    this.resizeObserver.disconnect();
    this.containerTarget.removeEventListener("scroll", this.onScrollOrResize);
  }

  scroll(direction) {
    const distance = this.containerTarget.clientWidth * 0.5; // halbe Breite scrollen
    const delta = direction === "right" ? distance : -distance;
    this.containerTarget.scrollBy({ left: delta, behavior: "smooth" });
  }

  scrollLeft() {
    this.scroll("left");
  }

  scrollRight() {
    this.scroll("right");
  }

  updateButtons() {
    const maxScroll =
      this.containerTarget.scrollWidth - this.containerTarget.clientWidth;
    const hasOverflow = maxScroll > 0;

    // Buttons nur zeigen, wenn Overflow existiert
    if (hasOverflow) {
      this.toggleOn(this.prevButtonTarget);
      this.toggleOn(this.nextButtonTarget);
    } else {
      this.toggleOff(this.prevButtonTarget);
      this.toggleOff(this.nextButtonTarget);
    }

    // Sichtbarkeit je nach Position
    if (hasOverflow) {
      if (this.containerTarget.scrollLeft <= 0) {
        this.toggleOff(this.prevButtonTarget);
      }
      if (this.containerTarget.scrollLeft >= maxScroll - 1) {
        this.toggleOff(this.nextButtonTarget);
      }
    }
  }

  toggleOff(element) {
    element.classList.add("hidden");
    element.classList.remove("map-button--flex");
  }

  toggleOn(element) {
    element.classList.remove("hidden");
    element.classList.add("map-button--flex");
  }
}
